var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheckCircleSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88Z",
    fill: "#56A012"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3198 62.3199C41.5198 62.3199 40.7598 61.9999 40.1998 61.4399L28.8798 50.1199C27.7198 48.9599 27.7198 47.0399 28.8798 45.8799C30.0398 44.7199 31.9598 44.7199 33.1198 45.8799L42.3198 55.0799L62.8798 34.5199C64.0398 33.3599 65.9598 33.3599 67.1198 34.5199C68.2798 35.6799 68.2798 37.5999 67.1198 38.7599L44.4398 61.4399C43.8798 61.9999 43.1198 62.3199 42.3198 62.3199Z",
    fill: "#56A012"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCheckCircleSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-check-circle-success.e75a817b315c19fcaa7d3622c65a3d39.svg";